import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {CoKpiComponent} from "../page/co-overview-page/components/kpiComponent/co-kpi.component";
import {CoStatisticsComponent} from "../page/co-overview-page/components/statisticsComponent/co-statistics.component";
import {CoOverviewPage} from "../page/co-overview-page/co-overview.page";
import {ChannelConfigPage} from "../page/overview/channel-config/channel-config.page";


const coModuleEntry: TestModuleDefinition = {
    key: 'co',
    label: 'Channel (co)',
    components: [
        {
            key: 'CoKpiComponent',
            component: CoKpiComponent,
            selector: 'co-kpi-component',
            type: 'OverviewKpiBaseComponent',
            label: 'co kpi component'
        },
        {
            key: 'CoStatisticsComponent',
            component: CoStatisticsComponent,
            selector: 'co-statistics-component',
            type: 'OverviewStatisticsBaseComponent',
            label: 'co statistics component'
        },
        {
            key: 'CoOverviewPage',
            component: CoOverviewPage,
            selector: 'mvs-example',
            type: 'PageComponent',
            label: 'co overview page'
        },
        {
            key: 'ChannelConfigPage',
            component: ChannelConfigPage,
            selector: 'mvs-co-channel-type-page',
            type: 'PageComponent',
            label: 'channel config page'
        }
    ]
}

export const CO_TEST_PROVIDERS: Provider[] = [
    {provide: TEST_MODULE_REGISTRY, useValue: coModuleEntry, multi: true}
];